"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MetrocommonTriangle = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var React = _interopRequireWildcard(require("react"));

var MetrocommonTriangle = function MetrocommonTriangle(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#78BE20' : _ref$color,
      props = (0, _objectWithoutProperties2.default)(_ref, ["color"]);
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "21.176",
    viewBox: "0 0 20 21.176",
    role: "img",
    "aria-labelledby": "triangleTitle"
  }, props), /*#__PURE__*/React.createElement("title", {
    id: "triangleTitle"
  }, "Decorative triangle"), /*#__PURE__*/React.createElement("path", {
    id: "Polygon_10",
    "data-name": "Polygon 10",
    d: "M10.588,0,21.176,20H0Z",
    transform: "translate(20) rotate(90)",
    fill: color
  }));
};

exports.MetrocommonTriangle = MetrocommonTriangle;